import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const AddTransmitSMSConnectionModal = React.lazy(
  () => import("./add-transmit-sms-connection.modal"),
);

const AddTransmitSMSConnection: iModalProps<
  typeof AddTransmitSMSConnectionModal
> = {
  name: "add-transmit-sms-connection",
  component: GenerateModalWithSuspense(AddTransmitSMSConnectionModal),
};

export default AddTransmitSMSConnection;
